import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { LocationLicenseOverviewKeys } from "modules/LocationLicenseOverview/queryKeys";
import { ApiInstance } from "utils/Api";

import type { ExactStandaloneLicense } from "models";

export type StandaloneLicensePayload = {
  license: ExactStandaloneLicense;
};

export const useSelectedStandaloneLicenceCreateMutation = () =>
  useTypedMutation<StandaloneLicensePayload, number>({
    mutationFn: async payload => (await ApiInstance.post("/licenses/standalone/create", payload, ENV.exactBaseURL)).data.exact_standalone_license_id,
    onSuccess: ({ license }, id) => {
      const licenses = typedQueryClient.getQueryData(LocationLicenseOverviewKeys.licenses);
      if (!licenses || licenses.standalone_licenses?.some(standaloneLicense => standaloneLicense.id === id)) return;

      typedQueryClient.setQueryData(LocationLicenseOverviewKeys.licenses, {
        ...licenses,
        standalone_licenses: [...(licenses.standalone_licenses ?? []), { ...license, id }]
      });
    }
  });
